import { TInsightsOnTagsResponse } from "../entities/insights-on-tags-response";
import { TInsightsOnTags } from "../entities/insights-on-tags";

export class InsightsOnTagsModel {
  static from(response: TInsightsOnTagsResponse): TInsightsOnTags {
    return {
      cards: response.cards,
      range: response.range,
      tags: {
        dataColumns: [
          {
            header: "Tag name",
            accessor: "id"
          },
          {
            header: "Unique visitors",
            accessor: "visitors"
          },
          {
            header: "First click",
            accessor: "primary",
            tooltipMessage: "The first tagged element the user has clicked on the creative."
          },
          {
            header: "Pre-conversion",
            accessor: "preConverted",
            tooltipMessage: "The last tagged element the user has clicked on the creative before converting."
          },
          {
            header: "Converted",
            accessor: "converted"
          },
        ],
        dataRows: response.insightsOnTags.map((tag) => ({
          ...tag,
        })),
      }
    }
  }
}